import {useCallback, useEffect, useRef, useState} from 'react';

/**
 * Состояние для ошибки, которая исчезает по таймеру
 */
export function useDisappearingError(): [error: string| null, setError: typeof setDisappearingError] {
    const errorTimeoutId = useRef<NodeJS.Timeout | null>(null);
    const [error, setError] = useState<string | null>(null);

    const setDisappearingError = useCallback((message: string | null, timeoutMs?: number, onDisappear?: () => void) => {
        if (errorTimeoutId.current) {
            clearTimeout(errorTimeoutId.current);
            errorTimeoutId.current = null;
        }

        setError(message);

        if (!timeoutMs) {
            return;
        }

        errorTimeoutId.current = setTimeout(() => {
            setError(null);
            onDisappear?.();
        }, timeoutMs);
    }, []);

    useEffect(() => {
        return () => {
            if (errorTimeoutId.current) {
                clearTimeout(errorTimeoutId.current);
            }
        };
    }, []);

    return [error, setDisappearingError];
}
